// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '메디젠헬스케어',
  targetSheetName: '수수료표',
  headerRowIndex: 3,
  headerRowCount: 1,
  dataStartRowIndex: 4,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '약가',
    commissionRate: '수수료',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '제약사',
    '제품명',
    '약가',
    '법인',
    '수수료',
    '효능',
    '오리지널 제품',
    '판매사명',
    '보험코드',
    '성분및 함량',
    '제조',
    '생동여부',
    '비고',
  ],
});
